import React from 'react';
import { FaPills } from 'react-icons/fa';

const ReadOnlyMedicineCartItem = ({ item }) => {
  return (
    <div className={`bg-gray-50 rounded-lg p-4 border ${item.is_out_of_stock ? 'border-red-300 bg-red-50' : 'border-gray-200'}`}>
      <div className="flex items-start gap-4 mb-3">
        {/* Medicine Image/Icon */}
        <div className="flex-shrink-0 w-20 h-20 bg-white rounded-lg border border-gray-200 flex items-center justify-center overflow-hidden relative">
          {item.service_item_image ? (
            <>
              <img 
                src={item.service_item_image} 
                alt={item.service_item_name}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  const iconDiv = e.target.parentElement.querySelector('.medicine-icon');
                  if (iconDiv) iconDiv.style.display = 'flex';
                }}
              />
              <div className="medicine-icon w-full h-full flex items-center justify-center absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-50" style={{ display: 'none' }}>
                <FaPills className="w-12 h-12 text-blue-400" />
              </div>
            </>
          ) : (
            <div className="medicine-icon w-full h-full flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50">
              <FaPills className="w-12 h-12 text-blue-400" />
            </div>
          )}
        </div>
        {/* Medicine Name */}
        <div className="flex-1">
          <h4 className={`font-medium ${item.is_out_of_stock ? 'text-red-600 line-through' : 'text-gray-900'}`}>
            {item.service_item_name || 'N/A'}
          </h4>
          {item.pack_size && (
            <p className="text-xs text-gray-600 mt-1">{item.pack_size}</p>
          )}
          {item.service_item_id && (
            <p className="text-xs text-gray-500 mt-1">ID: {item.service_item_id}</p>
          )}
        </div>
      </div>
      <div className="flex items-center justify-between gap-4 mb-3">
        <div className="flex items-center gap-4 flex-1">
          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-gray-700">MRP (₹):</label>
            <span className="text-sm font-semibold text-gray-900">
              {item.mrp_per_unit !== null && item.mrp_per_unit !== undefined 
                ? `₹${parseFloat(item.mrp_per_unit).toFixed(2)}` 
                : 'N/A'}
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-gray-700">AyushPay Price (₹):</label>
            <span className="text-sm font-semibold text-blue-600">
              {item.ayushpay_price_per_unit !== null && item.ayushpay_price_per_unit !== undefined 
                ? `₹${parseFloat(item.ayushpay_price_per_unit).toFixed(2)}` 
                : 'N/A'}
            </span>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">Quantity:</label>
          <span className="w-12 text-center font-medium text-gray-900">{item.quantity || 0}</span>
        </div>
      </div>
      {/* Out of Stock Badge */}
      {item.is_out_of_stock && (
        <div className="pt-2 mt-2 border-t border-red-200">
          <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800 border border-red-300">
            Out of Stock
          </span>
        </div>
      )}
    </div>
  );
};

export default ReadOnlyMedicineCartItem;

